import styles from './Breadcrumbs.module.scss';
import React from 'react';
import { Ssvg } from '../../../../Components/react/Ssvg';
import { collectionData, customBreadcrumbSteps } from '../../../configs';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useHierarchyContext } from '../../../hooks/useHierarchyContext';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../../constants/searchParamKeys';
import { updateDefaultFilters } from '../../../utils/updateDefaultFilters';
import { clsx } from '../../../../utils/clsx';
const Separator = () => (React.createElement("li", { "aria-hidden": "true", className: clsx('d:flex ai:center', styles.separator) },
    React.createElement(Ssvg, { icon: "#icon--arrow-breadcrumb", className: styles.icon })));
const CollectionSteps = () => {
    const { handle, medium } = useParams();
    const { objects } = useHierarchyContext();
    const [searchParams] = useSearchParams();
    const collectionObj = objects[handle];
    if (collectionObj === undefined) {
        return React.createElement(React.Fragment, null,
            React.createElement(Separator, null),
            React.createElement("li", null,
                React.createElement("span", { className: styles.item }, collectionData.title)));
    }
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    const searchParamsStr = searchParams.toString();
    return React.createElement(React.Fragment, null, collectionObj.pathToCurrent.map(({ name, handle }, i) => {
        const label = objects[handle]?.name ?? name;
        return React.createElement(React.Fragment, { key: label },
            React.createElement(Separator, null),
            React.createElement("li", null, i + 1 === collectionObj.pathToCurrent.length
                ? React.createElement("span", { className: styles.item }, label)
                : React.createElement(Link, { to: { pathname: `/collections/${handle}${medium !== undefined ? `/${medium}` : ''}`, ...(searchParamsStr.length > 0 && { search: `?${searchParamsStr}` }) }, className: styles.item, onClick: () => {
                        updateDefaultFilters(collectionObj.facetKey.replace(/lv\d/, `lv${i + 1}`), collectionObj.facetValue.split(' > ').slice(0, i + 1).join(' > '));
                    } }, label)));
    }));
};
export const Breadcrumbs = () => {
    const { handle } = useParams();
    const { loading } = useHierarchyContext();
    return (React.createElement("nav", { className: styles.container, "aria-label": "breadcrumb" },
        React.createElement("ol", { className: "list:none text:uppercase d:flex fxw:wrap ai:center" }, loading
            ? ['3em', '5em', '4em'].reduce((res, width, i) => {
                res.push(React.createElement("li", { key: i, className: clsx('skeleton bdrs:2 d:inline-block', styles.item), style: { height: '1em', width, margin: '0.188em 0' } }));
                if (i < 2) {
                    res.push(React.createElement(Separator, { key: `sep${i}` }));
                }
                return res;
            }, [])
            : React.createElement(React.Fragment, null,
                React.createElement("li", null,
                    React.createElement("a", { href: "/", className: styles.item }, "Home")),
                customBreadcrumbSteps?.map(({ url, title }) => {
                    return React.createElement(React.Fragment, { key: title },
                        React.createElement(Separator, null),
                        React.createElement("li", null,
                            React.createElement("a", { href: url, className: styles.item }, title)));
                }),
                handle !== undefined && React.createElement(CollectionSteps, null)))));
};
